// extracted by mini-css-extract-plugin
export default {"photosContainer":"Photos_photosContainer__teEkQ","photoFadeIn":"Photos_photoFadeIn__pZjJ-"};